import React, { useState, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  IconButton,
  Divider,
  Typography,
  Button,
	Grid,
} from '@material-ui/core';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import RefreshIcon from '@material-ui/icons/Refresh';
import TabletMacIcon from '@material-ui/icons/TabletMac';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';

import DateSelector from '../DateSelector';
import Placeholder from '../Placeholder';

import Progress from 'components/ProgressSpinner';

import {
	getMeterTypeDistribution,
} from 'modules/Analytics';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
		display: 'flex',
		flexDirection: 'column',
  },
	content: {
	},
	contentRoot: {
		minHeight: '428px',
		flexGrow: 1,
		padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    },
    position: 'relative'
	},
  chartContainer: {
    position: 'relative',
    height: '326px',
  },
	header: {
		height: '64px',
  },
  stats: {
		height: '',
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center'
  },
  device: {
    textAlign: 'center',
    padding: theme.spacing(1)
  },
  deviceIcon: {
    color: theme.palette.icon
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const UsersByDevice = props => {
  const { className, month, year, branch, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();

	const [ statusData, setStatusData ] = useState({});
	const [ loading, setLoading ] = useState(true);

	const [ dyear, setYear ] = useState((new Date()).getFullYear());
	const [ dmonth, setMonth ] = useState((new Date()).getMonth() + 1);

	console.log('MMMMMAAAA');

	useEffect(() => {

	if(!branch) return;

		setLoading(true);
		getMeterTypeDistribution({branchId: branch, year, month}).then(response => {
			console.log('Finished loading capturesStatus', response, 'for branch', branch);

			setStatusData(response);

			setLoading(false);

		});

	},[branch, year, month]);

	console.log('Status data is', statusData);

	let {
		analog,
		digital,
	} = statusData;

	analog = +analog;
	digital = +digital;

	const total = analog + digital;

	const p = +(100*digital/total).toFixed(1);
	const q = +(100 - (p)).toFixed(1);

	console.log('THEMEPALL', theme.palette);

	const pColor = '#5bc0de';//theme.palette.success.dark;
	const qColor = theme.palette.success.dark;
	const uColor = theme.palette.primary.light;
	const iColor = theme.palette.warning.main;

  const data = {
    datasets: [
      {
        data: [digital, analog],
        backgroundColor: [
					pColor,
					qColor,
        ],
        borderWidth: 8,
        borderColor: theme.palette.white,
        hoverBorderColor: theme.palette.white,
      }
    ],
    labels: ['Ultrassônicos', 'Analógicos']
  };

  const options = {
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    tooltips: {
      enabled: true,
      mode: 'index',
      intersect: false,
      borderWidth: 1,
      borderColor: theme.palette.divider,
      backgroundColor: '#FFF',//theme.palette.white,
      titleFontColor: theme.palette.text.primary,
      bodyFontColor: theme.palette.text.secondary,
      footerFontColor: theme.palette.text.secondary
    }
  };

	const v = (val) => {
		if(val === 0) return 0;
		if(!val) return '-';
		return val;
	}

  const devices = [
    {
      title: 'Ultrassônicos',
      value: v(p),
      icon: <LaptopMacIcon />,
      color: pColor,
    },
    {
      title: 'Analógicos',
      value: v(q),
      icon: <TabletMacIcon />,
      color: qColor,
    },
  ];

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
			elevation={4}
    >
      <CardHeader
				style={{height: '64px'}}
        title="Modelos de medidores"
      />
      <Divider />
      <CardContent className={classes.contentRoot}>
					{loading && <Progress />}
        {!loading && total === 0 ? 
					<Placeholder
						icon={PhotoLibraryIcon}
						text="Nenhuma captura encontrada no mês escolhido"
					/>
				:
					<>
				<div className={classes.chartContainer}>
          <Doughnut
            data={data}
            options={options}
          />
        </div>
        <Grid container className={classes.stats}>
          {devices.map(device => (
            <Grid
							item
              className={classes.device}
							xs={6}
              key={device.title}
            >
              <Typography variant="body1">{device.title}</Typography>
              <Typography
                style={{ color: device.color }}
                variant="h2"
              >
                {device.value}%
              </Typography>
            </Grid>
          ))}
        </Grid>
				</>
				}
      </CardContent>
    </Card>
  );
};

UsersByDevice.propTypes = {
  className: PropTypes.string
};

export default UsersByDevice;
